module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_f_leucistic.42aa6a36.png";